import React from "react";
const TipSetter = (props) => {
    return React.createElement("div", null, props?.tip);
};
export default TipSetter;
